import { render, staticRenderFns } from "./OnlineServicesTab.vue?vue&type=template&id=5a94c30a&scoped=true"
import script from "./OnlineServicesTab.vue?vue&type=script&lang=js"
export * from "./OnlineServicesTab.vue?vue&type=script&lang=js"
import style0 from "./OnlineServicesTab.vue?vue&type=style&index=0&id=5a94c30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a94c30a",
  null
  
)

export default component.exports